import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MobileListRenderItemInfo } from 'drf-react-by-schema';

import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import CheckIcon from '@mui/icons-material/Check';
import PauseIcon from '@mui/icons-material/Pause';

import { Layout } from 'src/styles';
import { FlocosProductionStatus } from 'src/constants';

import AsmubipButton from './AsmubipButton';
import StatusChip from './StatusChip';
import { ProductionKey } from 'src/constants/ProductionKey';

const MODEL = 'flocos_production';

export default function FlocosProductionCard({ item, id }: MobileListRenderItemInfo) {
  const navigate = useNavigate();
  const status = item.status.value.value as FlocosProductionStatus;
  const productionFinished = [
    FlocosProductionStatus.READY_TO_REVIEW,
    FlocosProductionStatus.REVIEWED,
    FlocosProductionStatus.COMPLETE,
  ].includes(status);
  return (
    <Card sx={Layout.mobileCard} variant="outlined">
      <CardContent sx={Layout.productionCardContent}>
        <Box sx={Layout.productionCardIconWrapper}>
          {productionFinished ? (
            <CheckIcon sx={Layout.productionCardIcon} />
          ) : (
            <PauseIcon sx={Layout.productionCardIcon} />
          )}
        </Box>
        <Box>
          {productionFinished ? (
            <Box>{item.peso_flocos_seco.valueStr} Kg de flocos</Box>
          ) : (
            <Box>Coleta de {item.data_coleta.valueStr}</Box>
          )}
          {item.perfil && (
            <Box sx={{ color: (theme) => theme.palette.primary.main }}>{item.perfil.valueStr}</Box>
          )}
          {item.grupo && <Box>{item.grupo.valueStr}</Box>}
          {item.comunidade && (
            <Box>
              <Typography variant="caption">{item.comunidade.valueStr}</Typography>
            </Box>
          )}
          {productionFinished ? (
            <Box>
              <Typography variant="body2">{item.data_coleta.valueStr}</Typography>
            </Box>
          ) : (
            <></>
          )}
          <Box>
            <Typography variant="caption">Lote: {item.lote.valueStr}</Typography>
          </Box>
          <StatusChip type={ProductionKey.FLOCOS} status={status} />
        </Box>
      </CardContent>
      <CardActions>
        {productionFinished ? (
          <Box sx={Layout.productionCardActionWrapper}>
            <AsmubipButton
              variant="outlined"
              size="large"
              sx={Layout.productionCardActionSingle}
              onClick={() => {
                navigate(`/${MODEL}/view/${id}`);
              }}>
              Ver detalhes
            </AsmubipButton>
            {/* <AsmubipButton
              variant="contained-dark"
              size="medium"
              startIcon={<WhatsAppIcon sx={{ color: 'inherit' }} />}>
              Compartilhar
            </AsmubipButton> */}
          </Box>
        ) : (
          <AsmubipButton
            variant="contained-dark"
            size="large"
            sx={Layout.productionCardActionSingle}
            onClick={() => {
              navigate(`/${MODEL}/edit/${id}`);
            }}>
            Editar
          </AsmubipButton>
        )}
      </CardActions>
    </Card>
  );
}
